import { SvgProps } from "../../types";

const Ai = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={21}
    fill="none"
    {...props}
  >
    <path
      fill={props.fill ?? "#1064ED"}
      fillRule="evenodd"
      d="M17.297 3.833v13.334H3.963V3.833h13.334ZM9.575 7.167H8.277l-2.465 6.666h1.171l.466-1.303h2.95l.456 1.303h1.242L9.575 7.167Zm4.602 0H13.01v6.666h1.167V7.167Zm-5.26 1.118 1.162 3.326H7.772l1.143-3.326Zm9.49 5.548h2.223v2.223h-2.222v-2.223ZM5.076 18.278h2.222V20.5H5.075v-2.222Zm4.444 0h2.222V20.5H9.52v-2.222ZM5.075.5h2.222v2.222H5.075V.5Zm8.889 17.778h2.222V20.5h-2.223v-2.222ZM9.518.5h2.222v2.222H9.52V.5Zm4.444 0h2.223v2.222h-2.223V.5Zm4.445 8.889h2.222v2.222h-2.222V9.39ZM.63 13.833h2.222v2.223H.63v-2.223Zm17.778-8.889h2.222v2.223h-2.222V4.944ZM.63 9.39h2.222v2.222H.63V9.39Zm0-4.445h2.222v2.223H.63V4.944Z"
      clipRule="evenodd"
    />
  </svg>
);
export default Ai;
